/**
 * Inline microphone SVG icon for reliable cross-platform rendering.
 *
 * Lucide's Mic icon has rendering issues on web via react-native-svg.
 * This uses the same SVG paths but renders directly for consistency.
 * @module features/voice-report/components/MicIcon/MicIconView
 */

import React, { memo } from "react";
import Svg, { Path, Rect } from "react-native-svg";

/**
 * Props for MicIconView
 */
interface MicIconViewProps {
  /** Stroke color for the icon */
  readonly color: string;
}

/**
 * Microphone SVG icon matching Lucide's Mic design.
 * @param props - Component props
 * @param props.color - Stroke color
 */
const MicIconView = ({ color }: MicIconViewProps) => (
  <Svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <Rect x={9} y={2} width={6} height={11} rx={3} />
    <Path d="M5 10a7 7 0 0 0 14 0" />
    <Path d="M12 17v4" />
    <Path d="M8 21h8" />
  </Svg>
);

MicIconView.displayName = "MicIconView";

export default memo(MicIconView);
